<template>
  <f-loader ref="loader">
    <simple-table
        :items="itemsFiltered"
        :format="format"
        :title="title"
        :page-size="pageSize===undefined?12:pageSize"
        :buttons="[...(button?[{id:'main', button:button}]:[]), ...(moreButtons||[])]"
        :search="true"
        :sort="true"
        :close="close"
        @click-item="doEmit?$emit('click-item', $event):$router.push({name: resource, params: {[identity || format[0][0]]: $event[identity || format[0][0]], ...params}})"
        @click-button="(doEmit||$event.id!='main')?$emit('click-button', $event):$router.push({name: 'new' + resource, params: params})"
        @click-close="doEmit?$emit('click-close'):0"
    />

  </f-loader>
</template>

<script>
import FLoader from "@/components/FLoader";
import SimpleTable from "@/components/simple-table/SimpleTable";
import {http} from "@/misc/http";

export default {
  components: {SimpleTable, FLoader},
  emits: ['click-item', 'click-button'],
  props: [
    "format",
    "url",
    "resource",

    "button",
    "moreButtons",

    "title",
    "identity",
    "pageSize",

    "doEmit",
    "close",
    "params",

    "itemsFilter",
  ],
  data() {
    return {
      items: [],
    }
  },

  async mounted() {
    await this.$refs.loader.wrap(async () => {
      this.items = await http.get(this.url);
    });
  },

  computed: {
    itemsFiltered() {
      if (!this.itemsFilter) return this.items;
      return this.items.filter(i => this.itemsFilter(i));
    },
  }

}
</script>

